import React from 'react';
import {Col, Row} from "reactstrap";
import ProgressiveImage from "react-progressive-image";
import "./index.css"
import assets from "../../../../../../util/assets";
import {PricingType} from "../../pricing/type";
import {getAgeGroupDiv} from "../../../../../../util/utility";
import {PricingSmall} from "../../pricing/small";
import PropTypes from "prop-types";

function GalleryVideoItem(props) {
    return (
        <div className="no-margin my-library-table-header publish-list-item-container"
             key={`my-library-row-video-${props.index}`}>
            <Row className="publish-list-item-display-flex-align-items-center">
                <Col md="10" className="no-padding">
                    <div className="display-flex">

                        <ProgressiveImage
                            delay={1000}
                            src={props.video.thumbnail_url}
                            placeholder="placeholder"
                        >
                            {(src, loading) => {
                                return loading ? (
                                        <img alt="my-library-thumbnail" className="my-library-thumbnail-dynamic"
                                             src={assets.clipstore.placeholder}/>
                                    ) :
                                    (
                                        <div className="my-library-thumbnail-dynamic-bg"
                                             style={{backgroundImage: "linear-gradient(to bottom, rgba(26, 26, 26, 0.32), rgba(41, 41, 41, 0.53)),url('" + props.video.thumbnail_url + "')"}}
                                             onClick={() => {
                                                 props.thumbnailClicked(props.video.id)
                                             }}>

                                            <PricingType content={props.video}/>
                                            <div className="my-library-thumbnail-duration-publish-container">
                                            <span
                                                className="my-library-thumbnail-duration-publish-text">{props.video.durationFormatted}</span>
                                            </div>
                                        </div>
                                    )

                            }}
                        </ProgressiveImage>

                        <div className="my-library-video-list">
                            <div className="my-library-video-title">
                                <span>{props.video.title}</span>
                            </div>
                            <div className="my-library-video-description">{props.video.description}</div>
                            <div
                                className="my-library-video-date display-flex-justify-video-flex-start-align-items-center">
                                <div className="badge badge-sm text-white">
                                    {getAgeGroupDiv(props.video.age_group, "age-group-24")}
                                </div>
                                <PricingSmall pricing={props.video.pricing}/>
                            </div>
                        </div>
                    </div>
                </Col>

                <Col md="1"
                     style={{textAlign: 'right'}}
                     onClick={() => {
                         props.editVideo(props.video.id)
                     }}
                     className="no-padding primary-color underline cursor-pointer">
                    Edit
                </Col>

                {
                    props.delete_videos.isFetching ?
                        <Col md="1"
                             style={{textAlign: 'right'}}
                             className="no-padding primary-color underline cursor-pointer">
                            <img src={assets.loading_blue} width={24} alt="loading"/>
                        </Col>
                        :
                        <Col md="1"
                             style={{textAlign: 'right'}}
                             onClick={() => {
                                 props.deleteVideo(props.video.id)
                             }}
                             className="no-padding primary-color underline cursor-pointer">
                            Delete
                        </Col>
                }


            </Row>
        </div>
    );
}

GalleryVideoItem.propTypes = {
    index: PropTypes.number.isRequired,
    video: PropTypes.object.isRequired,
    thumbnailClicked: PropTypes.func.isRequired,
    editVideo: PropTypes.func.isRequired,
    deleteVideo: PropTypes.func.isRequired,
};

export default GalleryVideoItem;